// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { ITheme, mergeStyles, useTheme } from '@fluentui/react';
import { Constants } from '../../constants';

export const FeedbackDialogPrivacyStatement = (): JSX.Element => {
  const theme = useTheme();
  return (
    <div className={privacyStatementContentStyle(theme)}>
      <span>
        {privacyStatementContent}{' '}
        <a href={Constants.PRIVACY_STATEMNT_LINK} target="_blank">
          {'Privacy Statement.'}
        </a>
      </span>
    </div>
  );
};

const privacyStatementContent =
  'By pressing submit, your feedback will be used to improve Microsoft products and services. Your IT admin will be able to collect this data. Based on your feedback, we may provide additional information to help you with your support issue.';

const privacyStatementContentStyle = (theme: ITheme): string =>
  mergeStyles({
    fontSize: '0.8rem',
    color: theme.palette.neutralTertiary,
    textAlign: 'justify'
  });
